var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15H21V11.6219C21 11.225 20.8406 10.8438 20.5594 10.5625L17.4375 7.44062C17.1562 7.15937 16.775 7 16.3781 7H15V5.5C15 4.67188 14.3281 4 13.5 4H3.5C2.67188 4 2 4.67188 2 5.5V15.5C2 16.3281 2.67188 17 3.5 17H4C4 18.6562 5.34375 20 7 20C8.65625 20 10 18.6562 10 17H14C14 18.6562 15.3438 20 17 20C18.6562 20 20 18.6562 20 17H21.5C21.775 17 22 16.775 22 16.5V15.5C22 15.225 21.775 15 21.5 15ZM7 18.5C6.17188 18.5 5.5 17.8281 5.5 17C5.5 16.1719 6.17188 15.5 7 15.5C7.82812 15.5 8.5 16.1719 8.5 17C8.5 17.8281 7.82812 18.5 7 18.5ZM17 18.5C16.1719 18.5 15.5 17.8281 15.5 17C15.5 16.1719 16.1719 15.5 17 15.5C17.8281 15.5 18.5 16.1719 18.5 17C18.5 17.8281 17.8281 18.5 17 18.5ZM19.5 12H15V8.5H16.3781L19.5 11.6219V12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.3ff20633127fa7c84e13580ab99364e0.svg";
export { ForwardRef as ReactComponent };